module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"error":"Ошибка при генерации QR-кода.","tryAgain":"Попробуйте снова."}}')
  delete Component.options._Ctor
}
